import { styled } from "@mui/material/styles";

const Span = styled('span')({});

export default Span;
